import http from './http-common';
import axios from 'axios';
import storage from '../factory/StorageFactory';
 
const get = () => {  
    
    let headerParams ={
        headers: {
          "Content-Type": "application/json",
          'Authorization':"Maybank" + " " + storage.getToken(),
          Pragma: 'no-cache'  //IE11
        }
    }
       
    let stateId = storage.getStateId();
    // return axios.get(`http://localhost:3000/SPreview.json`); 
    return http.get(`/api/v1/SMEDL/getSMEDLPreviewForm/${stateId}`,headerParams); 
};

const putTermsAndDeclare = (value) => {
  let headerParams ={
    headers: {
      "Content-Type": "application/json",
      'Authorization':"Maybank" + " " + storage.getToken()
    }
}

  let stateId = storage.getStateId();

  let params = {
    "StateId":stateId,
    "Request":value
  }
 
  return http.put(`/api/v1/SMEDL/putTermsandDeclarationForm`,params,headerParams);
}

const submit = (params) => {
  
  let headerParams ={
    headers: {
      "Content-Type": "application/json",
      'Authorization':"Maybank" + " " + storage.getToken()
    }
}

  let stateId = storage.getStateId();
  
  return http.put(`/api/v1/SMEDL/putSubmitwithFields/${stateId}`,params,headerParams);
}
 
 
export default {
  get,
  putTermsAndDeclare,
  submit
};